$(document).on('turbolinks:load', () =>{
	if (typeof gon != 'undefined' && typeof gon.is_member != 'undefined') {
		gon.is_member == true ? $('#tabs-member').tab('show') : $('#tabs-archer').tab('show');
	};
});